import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
    constructor(private auth: AuthService, private router: Router, private notify: NotificationService) { }

    /**
     * Determines whether the current user is allowed to activate the requested route based on required permissions.
     * 
     * If the route specifies a required permission in its data and the user does not have this permission,
     * the user is redirected to the home page and access is denied.
     * 
     * @param route - The activated route snapshot containing route data and parameters.
     * @returns `false` if no permission is specified or the user does not have the required permission; otherwise, `true`.
     */
    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredPermission = route.data['permission'];

        // if user does not have the required permission, redirect to home
        if (!requiredPermission || !this.auth.hasPermission(requiredPermission)) {
            this.notify.showNotification('error', 'You do not have permission to access this page.');
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
